import React, { useState, useEffect } from "react";
import CompanyHeader from "../../components/CompanyHeader";
import CompanySideMenu from "../../components/CompanySideMenu";
import CheckboxButton from "../../components/CheckboxButton";
import { useNavigate } from "react-router-dom";
import { getNotiSetting, createNotiSetting, editNotiSetting } from "../../reducers/companyContentManage"
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import CustomToast from "../../components/CustomToast";
import {LoadingSpinner} from "../../components/Icons";
import { PERMISSIONS } from '../../constants/index';
import ReturnButton from "../../components/ReturnButton";
import CustomButton from "../../components/CustomButton";
import Copyright from "../../components/Copyright";

const tableHeaders = [
    {
        title: "表示する",
    },
    {
        title: "コンテンツ",
    },
];

const NotificationSetting = () => {
    const navigate = useNavigate();
    const [disabledBtn, setDisabledBtn] = useState(true);
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const currentUser = useSelector((state: any) => state.currentUser);
    const { staffPermission } = currentUser;
    const {
        loading,
        success,
        error,
        notiSettingData,
    } = useSelector((state: any) => state.companyContentManage);
    //Access to this page is denied
    if(!staffPermission[PERMISSIONS.NEWS_NOTI_SETTING]) {
        return null;
    }
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        const data = "";
        dispatch(getNotiSetting(data));
    }, [dispatch]);

    const initData = [
        {
            name: "ニュース記事",
            value: notiSettingData.noti_from_news,
            field: "noti_from_news",
        },
        {
            name: "求人",
            value: notiSettingData.noti_from_jobs,
            field: "noti_from_jobs",
        },
        {
            name: "メッセージ",
            value: notiSettingData.noti_from_message,
            field: "noti_from_message",
        },
        {
            name: "運営からのお知らせ（メンテナンス情報など）",
            value: notiSettingData.noti_from_system,
            field: "noti_from_system",
        },
    ];

    const [formData, setFormData] = useState(initData);

    const handleChange = (position: any) => {
        setDisabledBtn(false)
        setFormData((prev) =>
        prev.map((data, idx) =>
            position === idx ? { ...data, value: !data.value } : { ...data }
        )
        );
    };

    interface NotiSettingActions {
        noti_from_news: boolean;
        noti_from_jobs: boolean;
        noti_from_message: boolean;
        noti_from_system: boolean;
    }
    const handleSubmit = () => {
        setDisabledBtn(true)
        const requestBody: NotiSettingActions = formData.reduce((acc: any, item: any) => {
            acc[item.field] = item.value;
            return acc;
        }, {});
        const data = {
            requestBody
        };
        if(notiSettingData.id) {
            dispatch(editNotiSetting(data))
        }
        else{
            dispatch(createNotiSetting(data))
        }
    }

    useEffect(() => {
        if(notiSettingData){
            setFormData(initData)
        }
    }, [notiSettingData])

    useEffect(() => {
        if(success){
            enqueueSnackbar("I love snacks.", {
            content: (key) => (
                <CustomToast
                title={"メッセージ"}
                message={success}
                variant={"success"}
                snackbarKey={key}
                closeSnackbar={closeSnackbar}
                />
            ),
            });
        }
        else if(error) {
            enqueueSnackbar("I love snacks.", {
            content: (key) => (
                <CustomToast
                title={"メッセージ"}
                message={error}
                variant={"error"}
                snackbarKey={key}
                closeSnackbar={closeSnackbar}
                />
            ),
            });
        }
    }, [error, success]);

    return (
        <>
        <CompanyHeader />
        <div className="mt-6 px-6 flex gap-6 relative">
            <CompanySideMenu />
            <div className="flex-1">
            <div className="mb-4 flex items-center gap-4">
                <ReturnButton onClick={() => navigate(-1)} />
                <span className="text-sm alu-text-base-1">/</span>
                <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
                お知らせ枠の管理
                </h3>
            </div>
            <h5 className="mb-6 text-base alu-text-base-1">
                タレント向けに発信したいお知らせコンテンツを選択します
            </h5>

            <div className="mb-6 p-6 rounded-lg bg-white alu-section-box-shadow">
                <h5 className="mb-4 font-bold text-base alu-text-base-2">
                お知らせに表示するコンテンツ
                </h5>
                <div className="bg-white">
                <table className="table-auto w-full">
                    <thead className="border-b alu-border px-4 py-2">
                        <tr>
                            {tableHeaders.map((header, idx) => (
                            <th key={idx} className="px-4 py-2 text-left">
                                <div className="flex items-center">
                                <p className="font-normal text-sm leading-[1.3125] alu-text-base-2">
                                    {header.title}
                                </p>
                                </div>
                            </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                    {formData.map((data, idx) => (
                        <tr className="hover:bg-[#fff3e5]" key={idx}>
                            <td className="w-[90px] py-5 font-normal text-sm leading-[1.3125]">
                                <div className="flex justify-center -ml-6">
                                    <CheckboxButton
                                    name={data.field}
                                    value={data.value}
                                    onChange={() => handleChange(idx)}
                                    />
                                </div>
                            </td>
                            <td className="px-4 py-5 text-left font-normal text-base alu-text-base-2">
                                {data.name}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
            <CustomButton
                type="button"
                size="md"
                onClick={handleSubmit}
                disabled={disabledBtn || loading}
            >
                <p>{loading ? "保存中..." : "保存"}</p>
                {loading && (
                <span><LoadingSpinner /></span>
                )}
            </CustomButton>
            </div>
        </div>
        <Copyright view="company" />
        </>
    );
};

export default NotificationSetting;
